
export default function Leadership() {
  const leaders = [
    {
      role: 'CEO & COO',
      title: 'Chief Executive & Operations Officer',
      description: 'Former CEO who guided an MSC-status company from 2006 to market dominance. University of Science, Malaysia (USM) graduate with First-Class Honours in Business Management. Expert in scaling technology ventures and operational excellence.',
      icon: 'ri-user-star-line',
    },
    {
      role: 'CTO',
      title: 'Chief Technology Officer',
      description: 'Seasoned technology leader from well-known companies with deep expertise in AI, machine learning, and scalable platform architecture.',
      icon: 'ri-code-s-slash-line',
    },
    {
      role: 'CFO',
      title: 'Chief Financial Officer',
      description: 'Experienced finance executive from established corporations, specialising in sustainable business models and strategic financial planning.',
      icon: 'ri-money-dollar-box-line',
    },
  ];

  return (
    <section id="leadership" className="py-24 bg-gray-900">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-flex items-center bg-white/10 rounded-full px-4 py-2 mb-4">
            <i className="ri-team-line text-teal-400 mr-2 w-4 h-4 flex items-center justify-center"></i>
            <span className="text-xs font-medium text-teal-300" style={{ fontFamily: "'Inter', sans-serif" }}>
              Seasoned Leadership Team
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Led by Industry Veterans
          </h2>
          <p className="text-base text-gray-400 max-w-2xl mx-auto" style={{ fontFamily: "'Inter', sans-serif" }}>
            Our venture is spearheaded by a seasoned leadership team with proven track records in technology, business, and finance.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {leaders.map((leader, index) => (
            <div
              key={index}
              className={`bg-gray-800 rounded-lg p-8 hover:bg-gray-750 transition-all hover:-translate-y-1 ${index === 0 ? 'md:col-span-1' : ''}`}
            >
              <div className="w-16 h-16 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mb-6 mx-auto">
                <i className={`${leader.icon} text-3xl text-white w-8 h-8 flex items-center justify-center`}></i>
              </div>
              <p className="text-teal-400 text-sm font-bold text-center mb-1" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {leader.role}
              </p>
              <h3 className="text-lg font-bold text-white text-center mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                {leader.title}
              </h3>
              <p className="text-sm text-gray-400 text-center leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
                {leader.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
